<template>
  <div v-if="parent.concat(children).length > 0">
    <div class="hidden lg:block">
      <h3 class="heading-3">
        {{ i18n(translations.landingNavigationSeoTitle) }}
      </h3>
      <ul v-for="(item, index) in parent" :key="item.title">
        <li :style="`margin-left: ${index * 1}rem`">
          <RevLink
            :to="item.link.href"
            :underlined="item.id === pageId"
            @click="trackClick(toTrackingData(item.title))"
          >
            {{ item.title }}
          </RevLink>
          <template v-if="item.id === pageId">
            <ul class="ml-16">
              <li v-for="child in visibleChildren" :key="child.title">
                <h4>
                  <RevLink
                    :to="child.link.href"
                    :underlined="false"
                    @click="trackClick(toTrackingData(child.title))"
                  >
                    {{ child.title }}
                  </RevLink>
                </h4>
              </li>
            </ul>
          </template>
        </li>
      </ul>
      <RevLink @click="isExpanded = !isExpanded">
        {{
          isExpanded ? i18n(translations.viewLess) : i18n(translations.viewMore)
        }}
      </RevLink>
    </div>
    <ul class="flex snap-x gap-8 overflow-scroll scrollbar-none lg:hidden">
      <li
        v-for="item in parent.concat(children)"
        :key="item.id"
        class="inline-block snap-start lg:hidden"
      >
        <RevButtonTiny
          :to="item.link.href"
          :underlined="item.id === pageId"
          variant="secondary"
          @click="trackClick(toTrackingData(item.title))"
        >
          {{ item.title }}
        </RevButtonTiny>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonTiny } from '@ds/components/ButtonTiny'
import { RevLink } from '@ds/components/Link'

import { useProductListSideNavigation } from '../composables/useProductListSideNavigation'

import translations from './SideNavigation.translations'

const { pageId } = defineProps<{
  pageId: string
}>()

const isExpanded = ref(false)
const { parent, visibleChildren, children } = useProductListSideNavigation(
  pageId,
  isExpanded,
)

const i18n = useI18n()

const { trackClick } = useTracking()
function toTrackingData(name: string) {
  return {
    name,
    zone: 'product list > seo nav',
  }
}
</script>
